module.exports = __webpack_public_path__ + "font_beautiful.ab9223c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/font_beautiful.png
// module id = Pjz/
// module chunks = 0